export default __webpack_public_path__ + "static/media/contestImg.a831aa17.jpg";